module.exports = __webpack_public_path__ + "static/media/video2.7fb53ad.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video2.mp4
// module id = UaBA
// module chunks = 1